import { render, staticRenderFns } from "./Logos.vue?vue&type=template&id=3a3428cd&scoped=true"
import script from "./Logos.vue?vue&type=script&lang=js"
export * from "./Logos.vue?vue&type=script&lang=js"
import style0 from "./Logos.vue?vue&type=style&index=0&id=3a3428cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3428cd",
  null
  
)

export default component.exports